import { render, staticRenderFns } from "./MetalPricesShortcode.vue?vue&type=template&id=55ab64c3&scoped=true"
import script from "./MetalPricesShortcode.vue?vue&type=script&lang=js"
export * from "./MetalPricesShortcode.vue?vue&type=script&lang=js"
import style0 from "./MetalPricesShortcode.vue?vue&type=style&index=0&id=55ab64c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab64c3",
  null
  
)

export default component.exports